import type { InputArg } from "./InputArg"
import { mergeMock } from "./mergeMock"

export const mockData = <T>(data: T) => {
  return (...inputs: InputArg<T>[]) => {
    if (inputs.length === 0) return mergeMock(data, undefined)
    return inputs.reduce((data, input) => mergeMock(data, input), data)
  }
}
